import React from 'react'
import { useSelector, useDispatch } from 'react-redux'
import { setStep } from '../store/byoSlice'
import ProductTile from './ProductTile.jsx'

const Products = ({ data }) => {

  const { step, addons } = useSelector((state) => state.byo)
  const dispatch = useDispatch()

  let nextStep = step + 1
  if (step === 2 && (!data.addons || data.addons.length === 0)) {
    nextStep = 4
    if (typeof data.addons2 === 'undefined' || !data.addons2) nextStep = 5
  } else if (step === 3 && (typeof data.addons2 === 'undefined' || !data.addons2))
    nextStep = 5

  let previousStep = step - 1;

  if (step === 5 && (!data.addons2 || typeof data.addons2 === 'undefined')) {
    previousStep = 3;
    if (data.addons.length === 0) {
      previousStep = 2;
    }
  } else if (step === 4 && (data.addons && data.addons.length === 0)) {

    previousStep = 2;
  }



  const renderProducts = () => {
    if (step === 1)
      return data.metafields.color.map((option, optionIndex) =>
        <div key={`color-${optionIndex}`}>
          <ProductTile data={{ data: data, option: option, optionIndex: optionIndex }} />
        </div>
      )
    else if (step === 2)
      return data.metafields.material.map((option, optionIndex) =>

        <ProductTile key={`material-${optionIndex}`} data={{ data: data, option: option, optionIndex: optionIndex }} />

      )
    else if (step === 3) {
      return data.addons && Array.isArray(data.addons)
        ? data.addons.map((addon, addonIndex) =>
          addon.variants && Array.isArray(addon.variants)
            ? addon.variants
              .filter((variant) => variant.metafields && variant.metafields.addon && variant.data.available)
              .map((variant) => (
                <div key={`addon-${addon.product.id}-${variant.data.id}`}>
                  <ProductTile data={{ data: data, productId: addon.product.id, variantId: variant.data.id }} />
                </div>
              ))
            : null
        )
        : null;
    }


    else if (step === 4)
      return data.addons2.map((addon, addonInex) =>
        addon.variants.filter((variant) => variant.metafields && variant.metafields.addon && variant.data.available)
          .map((variant) => <div key={`addon-${addon.product.id}-${variant.data.id}`}>
            <ProductTile data={{ data: data, productId: addon.product.id, variantId: variant.data.id }} />
          </div>)
      )
  }

  const isAddonSelected = () => {
    const dataAddons = step === 3 ? data.addons : data.addons2;

    return (
      dataAddons &&
      Array.isArray(dataAddons) &&
      dataAddons.filter((addon) =>
        addons.filter((a) => {
          const product = addon && addon.product;
          const variants = addon && addon.variants;

          return (
            product &&
            variants &&
            Array.isArray(variants) &&
            variants.filter((v) => v.data.id === a.variantId).length > 0
          );
        }).length > 0
      ).length
    );
  };


  const modalItem = (productOption, addon = null, variant = null) => {
    let displayTitle = productOption ? productOption.detail_title : (addon.metafields && addon.metafields.detail_title ? addon.metafields.detail_title : addon.product.title)
    let productImage = productOption ? productOption.option_image : (variant && variant.data.featured_image ? variant.data.featured_image.src : ((addon && addon.product.featured_image) ? addon.product.featured_image : null))
    let description = productOption ? productOption.description : (addon.metafields && addon.metafields.short_description ? addon.metafields.short_description : null)
    let tags = productOption ? productOption.tags : (addon.metafields && addon.metafields.tags ? addon.metafields.tags : null)
    let popupMedia = productOption ? productOption.popup_media : (addon.metafields && addon.metafields.popup_media.preview_image.src ? (addon.metafields.popup_media.media_type === "image" ? addon.metafields.popup_media.preview_image.src : addon.metafields.popup_media) : null)
    return <div>
      <div className={`pb-4 mb-2 ${productOption && productOption.value_props_title ? 'border-b border-black' : ''}`}>
        {
          popupMedia &&
          (popupMedia.media_type == 'video' ?
            <div className='relative h-0 mb-3' style={{ paddingBottom: `${1 / popupMedia.aspect_ratio * 70}%` }}>
              <video className='!w-full !h-full lg:!h-[222px] object-cover bg-white absolute top-0 left-0' width="120" autoPlay muted playsInline preload="metadata" height="140" controls>
                {
                  popupMedia.sources.map((source, index) =>
                    <source src={source.url} type={source.mime_type} key={`popup-media-${index}`} />
                  )
                }
                Your browser does not support the video tag.
              </video>

            </div> :
            <img className='max-w-full mb-3' src={popupMedia} alt={displayTitle} />
          )
        }
        <h2 className='mb-3 text-base font-semibold text-puffco-light-black-3'>{displayTitle}</h2>
        <div className='flex'>
          {productImage ?
            <div className='relative overflow-hidden w-[6.25rem] h-[6.25rem] mr-3'>
              <img className='absolute top-1/2 left-1/2 transform -translate-x-1/2 -translate-y-1/2 w-full h-full object-contain' src={productImage.replace('.jpg?', '.jpg?width=150&').replace('.png?', '.png?width=150&').replace('.webp?', '.webp?width=150&')} />
            </div> : null
          }
          <div className={`${productImage ? 'max-w-[calc(100%-7rem)]' : ''}`}>
            {
              description ? <div className={`text-xs mb-3`}>{description}</div> : null
            }
            {step === 1 ? <div className='text-puffco-grey-6 text-[0.75rem] leading-3'>Proxy Base is not sold separately.</div> : ''}
            {
              tags && tags.length > 0 ?
                <div className='flow-root mt-6'>
                  {
                    tags.map((tag, index) =>
                      <span className={`inline-flex px-3 py-2 text-puffco-grey-3 rounded-full capitalize float-left bg-puffco-grey-5 ${tags.length - 1 == index ? '' : 'mr-2'} mb-2 font-mono text-[0.75rem] leading-3`} key={`${step}-tag-${index}`}>{tag}</span>
                    )
                  }
                </div>
                : null
            }
          </div>
        </div>
      </div>
      {
        productOption && productOption.value_props_title && <div className='mb-3 font-bold text-xs'>{productOption.value_props_title}</div>
      }
      {
        productOption && productOption.value_prop_images &&
        <div className='flex flex-wrap gap-3'>
          {
            productOption.value_prop_images.map((image, index) =>
              <div className='w-[4.6875rem]' key={`value-prop-image-${index}`}>
                <div className='h-[4.6875rem] w-full relative overflow-hideen'>
                  <img className='absolute top-1/2 left-1/2 transform -translate-x-1/2 -translate-y-1/2 w-full h-full object-contain' src={image.url} alt={image.alt} />
                </div>
                {image.alt && <span className='font-mono text-xs text-puffco-light-black-3 leading-6 text-center inline-flex items-center'>{image.alt}</span>}
              </div>
            )
          }
        </div>
      }
    </div>
  }

  const modalHtml = () => {
    return <div>
      {data.steps[step - 1] && data.steps[step - 1].modal_title != '' && <div className='text-right text-xl leading-8 font-medium	 mb-3' dangerouslySetInnerHTML={{ __html: data.steps[step - 1].modal_title }} />}
      <div className='flex flex-col gap-10'>
        {
          step === 1 ? data.metafields.color.map((option, index) =>
            <div key={`${step}-modal-product-${index}`}>{modalItem(option)}</div>
          ) : ''
        }
        {
          step === 2 ? data.metafields.material.map((option, index) =>
            <div key={`${step}-modal-product-${index}`}>{modalItem(option)}</div>
          ) : ''
        }
        {
          step === 3 && data.addons ? data.addons.map((addon, addonIndex) =>
            addon.variants && addon.variants.filter((variant) => variant.metafields && variant.metafields.addon)
              .map((variant) =>
                <div key={`${step}-modal-product-${variant.data.id}`}>
                  {
                    modalItem(null, addon, variant)
                  }
                </div>
              )
          ) : ''
        }

        {
          step === 4 ? data.addons2.map((addon, addonInex) =>
            addon.variants.filter((variant) => variant.metafields && variant.metafields.addon)
              .map((variant) =>
                <div key={`${step}-modal-product-${variant.data.id}`}>
                  {
                    modalItem(null, addon, variant)
                  }
                </div>
              )
          ) : ''
        }
      </div>
    </div>
  }

  const openModal = () => {
    openPuffcoModal(document.querySelector('#mobileProductContents').innerHTML)
  }

  return (
    <div className='pt-4 pb-16 lg:pb-0 w-full lg:w-3/5 h-full'>
      <div className='flex flex-col justify-between h-[calc(100%-5rem)] relative'>
        <div className='lg:border-b lg:border-puffco-grey-7 px-4 lg:px-6'>
          <div className='pb-[2.75rem] hidden lg:pt-[50px] lg:flex justify-between items-center'>
            <a href='/' className='inline-block'>
              <img src={data.puffcoLogo} alt="Puffco logo" className='h-fit max-h-[40px] w-fit max-w-[23px]' />
            </a>
            <a href={data.ctaLink} className='inline-block text-xs underline underline-offset-4'>
              {data.ctaLabel}
            </a>
          </div>
          <div className='flex justify-between items-center flex-row-reverse lg:flex-col flex-nowrap lg:flex-wrap relative gap-4 mt-2 lg:mt-0'>
            <div className='flex items-center justify-between w-fit lg:w-full'>
              <p className='uppercase text-base lg:text-20 font-mono mb-2 hidden lg:block order-1'>Step {step}</p>
              <button type="button" className="order-2 lg:hidden" dangerouslySetInnerHTML={{ __html: data.infoIcon }} aria-label="Products Information" onClick={() => openModal()} /> </div>
            {data.steps[step - 1] && data.steps[step - 1].title != '' &&
              <div className="order-1 lg:order-3">
                <div className='text-2xl leading-10 tracking-[2px] hidden lg:block mb-6 [&_strong]:font-semibold' dangerouslySetInnerHTML={{ __html: data.steps[step - 1].title }} />
                <div className='text-18 leading-5 block lg:hidden' dangerouslySetInnerHTML={{ __html: data.steps[step - 1].title_mobile }} />
              </div>
            }
          </div>
        </div>
        <div className='pl-3 pr-8 lg:pl-6 lg:pr-6 py-6 lg:h-[calc(100%-3rem)] overflow-auto mb-4'>
          <div className='flex flex-nowrap lg:grid grid-cols-2 gap-3 lg:gap-4'>
            {renderProducts()}
          </div>
        </div>
      </div>
      <div className='hidden lg:flex items-center justify-between px-6'>
        {step > 1 ? <button className={` text-puffco-light-black-3 font-mono text-xs h-[2.125rem] inlinex-flex items-center justify-between px-4 before:content-[''] before:w-2 before:h-2 before:border-black before:border-l-2 before:border-t-2 before:inline-block before:mr-3 before:transform before:rotate-[-45deg]`} onClick={() => dispatch(setStep(previousStep))}>Back</button> : <span><span></span></span>}
        <button className={`bg-black uppercase font-mono text-xs text-white rounded-md h-[2.125rem] inlinex-flex items-center justify-between px-4 after:content-[''] after:w-2 after:h-2 after:border-white after:border-l-2 after:border-t-2 after:inline-block after:ml-3 after:transform after:rotate-[135deg]`}
          onClick={() => dispatch(setStep(nextStep))}>
          {step < 3 ? 'Next' : (nextStep == 5 ? 'Finish' : (isAddonSelected() ? 'Next' : 'No Thanks'))}
        </button>
      </div>
      <div className='hidden' id="mobileProductContents">{modalHtml()}</div>
    </div>
  )
}

export default Products

